
export interface ValidationError {
  field: string;
  message: string;
}

export function validateEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function validatePhone(phone: string): boolean {
  // Remove all non-digit characters
  const digits = phone.replace(/\D/g, '');
  // Check if it's a valid US phone number (10 digits)
  return digits.length === 10;
}

export function validateBookingStep1(selectedProvider: string): ValidationError[] {
  const errors: ValidationError[] = [];
  
  if (!selectedProvider) {
    errors.push({ field: 'provider', message: 'Please select a provider' });
  }
  
  return errors;
}

export function validateBookingStep2(selectedDate: Date | undefined, selectedTime: string): ValidationError[] {
  const errors: ValidationError[] = [];
  
  if (!selectedDate) {
    errors.push({ field: 'date', message: 'Please select a date' });
  }
  
  if (!selectedTime) {
    errors.push({ field: 'time', message: 'Please select a time' });
  }
  
  return errors;
}

export function validatePatientInfo(patientInfo: {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}): ValidationError[] {
  const errors: ValidationError[] = [];
  
  if (!patientInfo.firstName.trim()) {
    errors.push({ field: 'firstName', message: 'First name is required' });
  }
  
  if (!patientInfo.lastName.trim()) {
    errors.push({ field: 'lastName', message: 'Last name is required' });
  }
  
  if (!patientInfo.email.trim()) {
    errors.push({ field: 'email', message: 'Email is required' });
  } else if (!validateEmail(patientInfo.email)) {
    errors.push({ field: 'email', message: 'Please enter a valid email address' });
  }
  
  if (!patientInfo.phone.trim()) {
    errors.push({ field: 'phone', message: 'Phone number is required' });
  } else if (!validatePhone(patientInfo.phone)) {
    errors.push({ field: 'phone', message: 'Please enter a valid 10-digit phone number' });
  }
  
  return errors;
}
